import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import PublicProfile from './pages/PublicProfile';
import CommunityPage from './pages/CommunityPage';
import GroupsPage from './pages/GroupsPage';
import GroupDetailPage from './pages/GroupDetailPage';
import Login from './pages/Login';
import Register from './pages/Register';
import Onboarding from './pages/Onboarding';
import CourseDetailPage from './pages/CourseDetailPage';
import CoursesPage from './pages/CoursesPage';
import Course1Page from './pages/Course1Page';
import Course2Page from './pages/Course2Page';
import Course3Page from './pages/Course3Page';
import EIISCoffeePage from './pages/EIISCoffeePage';
import CoffeeDetailPage from './pages/CoffeeDetailPage';
import MyCoffeePage from './pages/MyCoffeePage';
import ChallengesPage from './pages/ChallengesPage';
export function App() {
  useEffect(() => {
    document.title = 'Greenback Social Learning';
  }, []);
  return <BrowserRouter data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/login" element={<Login data-id="element-3" />} data-id="element-2" />
        <Route path="/register" element={<Register data-id="element-5" />} data-id="element-4" />
        <Route path="/onboarding" element={<Onboarding data-id="element-7" />} data-id="element-6" />
        <Route path="/" element={<Layout data-id="element-9" />} data-id="element-8" />
        <Route path="/community" element={<CommunityPage data-id="element-11" />} data-id="element-10" />
        <Route path="/courses" element={<CoursesPage data-id="element-13" />} data-id="element-12" />
        <Route path="/groups" element={<GroupsPage data-id="element-15" />} data-id="element-14" />
        <Route path="/groups/:groupId" element={<GroupDetailPage data-id="element-17" />} data-id="element-16" />
        <Route path="/challenges" element={<ChallengesPage data-id="element-19" />} data-id="element-18" />
        <Route path="/public-profile" element={<PublicProfile data-id="element-21" />} data-id="element-20" />
        <Route path="/public-profile/:userId" element={<PublicProfile data-id="element-23" />} data-id="element-22" />
        <Route path="/corso" element={<CourseDetailPage data-id="element-25" />} data-id="element-24" />
        <Route path="/corso/1" element={<Course1Page data-id="element-27" />} data-id="element-26" />
        <Route path="/corso/2" element={<Course2Page data-id="element-29" />} data-id="element-28" />
        <Route path="/corso/3" element={<Course3Page data-id="element-31" />} data-id="element-30" />
        <Route path="/coffee" element={<EIISCoffeePage data-id="element-33" />} data-id="element-32" />
        <Route path="/coffee/my-events" element={<MyCoffeePage data-id="element-35" />} data-id="element-34" />
        <Route path="/coffee/:coffeeId" element={<CoffeeDetailPage data-id="element-37" />} data-id="element-36" />
      </Routes>
    </BrowserRouter>;
}